import React, { useState, useEffect, useRef } from "react";
import ImageEditor from "../ImageEditor/ImageEditor";
import History from "./History";
import { useImage } from "../../context/ImageContext";
import ImageModal from "../MainCreate/ImageModal";
import { lowQualityToHighQuality } from "../../config/aws";

const All_History = [
    {
        "product": "Table1",
        "accessory": "True",
        "act_on_area": "Add",
        "time": "15:33, Jan 25, 2025",
        "Prompt": "A wooden chair on a grassy lawn ",
        "images": [
            {
                src: "https://storage.googleapis.com/a1aa/image/mw2TKNQZ0U2Z70hUZbxELvEjTcFD7k4p3NQfg2gx_FA.jpg",
                alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/FzAnFBYrF2g6I2cw8ZW7O8sFF5VDbC07owOmDBvgFMU.jpg",
                alt: "A wooden chair on a grassy lawn",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/R8jbdaH5htRGtR3AkGkIFgnClxyrGygZ11WT_OznLXg.jpg",
                alt: "A modern black chair with a unique backrest design",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/mw2TKNQZ0U2Z70hUZbxELvEjTcFD7k4p3NQfg2gx_FA.jpg",
                alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
            }
        ]
    },
    {
        "product": "Table2",
        "accessory": "False",
        "act_on_area": "Remove",
        "time": "15:33, Jan 25, 2025",
        "Prompt": "A wooden chair on a grassy lawn",
        "images": [
            {
                src: "https://storage.googleapis.com/a1aa/image/FzAnFBYrF2g6I2cw8ZW7O8sFF5VDbC07owOmDBvgFMU.jpg",
                alt: "A wooden chair on a grassy lawn",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/R8jbdaH5htRGtR3AkGkIFgnClxyrGygZ11WT_OznLXg.jpg",
                alt: "A modern black chair with a unique backrest design",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/mw2TKNQZ0U2Z70hUZbxELvEjTcFD7k4p3NQfg2gx_FA.jpg",
                alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/mw2TKNQZ0U2Z70hUZbxELvEjTcFD7k4p3NQfg2gx_FA.jpg",
                alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
            }
        ]
    },
    {
        "product": "Table3",
        "accessory": "True",
        "act_on_area": "Add",
        "time": "15:33, Jan 25, 2025",
        "Prompt": "A wooden chair on a grassy lawn",
        "images": [
            {
                src: "https://storage.googleapis.com/a1aa/image/mw2TKNQZ0U2Z70hUZbxELvEjTcFD7k4p3NQfg2gx_FA.jpg",
                alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/R8jbdaH5htRGtR3AkGkIFgnClxyrGygZ11WT_OznLXg.jpg",
                alt: "A modern black chair with a unique backrest design",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/mw2TKNQZ0U2Z70hUZbxELvEjTcFD7k4p3NQfg2gx_FA.jpg",
                alt: "A black armchair with a matching footstool in a room with wooden flooring and large windows",
            },
            {
                src: "https://storage.googleapis.com/a1aa/image/FzAnFBYrF2g6I2cw8ZW7O8sFF5VDbC07owOmDBvgFMU.jpg",
                alt: "A wooden chair on a grassy lawn",
            }
        ]
    },
];

const MainEdit = ({ editUploadedImages, setEditUploadedImages, brushSize, eraserSize, activeButton, allEditHistory, setAllEditHistory, editPageNumber, setEditPageNumber, selectedGroup, setSelectedGroup, creditsAvailable, setCreditsAvailable }) => {
    const [modalImage, setModalImage] = useState(null);
    const { activeTab, setActiveTab } = useImage();
    const containerRef = useRef(null);

    // useEffect(() => {
    //     if (editUploadedImages !== selectedGroup) {
    //         setSelectedGroup(editUploadedImages);
    //     }
    // }, [editUploadedImages]);



    useEffect(() => {
        const loadHighQualityImages = async () => {

            const updatedImages = [...allEditHistory[0].images];
            for (let i = 0; i < updatedImages.length; i++) {
                // console.log("in MainEdit useEffect allEditHistory changed   fetching high quality images");
                updatedImages[i] = {
                    ...updatedImages[i],
                    src: updatedImages[i].src.includes("lowQuality") ? await lowQualityToHighQuality(updatedImages[i].src) : updatedImages[i].src
                };
            }
            setSelectedGroup(updatedImages);
        };


        if (allEditHistory.length > 0) {
            // loadHighQualityImages();
            setSelectedGroup(allEditHistory[0].images);
        }

    }, [allEditHistory]);

    useEffect(() => {
        // console.log(" selectedGroup changed fetching high quality images");
        selectedGroup.forEach(image => {
            if (image.src.includes("lowQuality")) {
                // console.log("in MainEdit useEffect selectedGroup changed    fetching high quality images");
                lowQualityToHighQuality(image.src).then(highQualityUrl => {
                    image.src = highQualityUrl;
                });
            }
        });
    }, [selectedGroup]);

    const handleDownload = (image) => {
        if (!image) return;
        const link = document.createElement('a');
        link.href = image.src;
        link.download = `image.jpg`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <div className="overflow-y-auto h-full" style={{ maxHeight: '100vh' }} ref={containerRef}>
            {allEditHistory.length === 0 ? (
                <div className="flex items-center justify-center h-full">
                    <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
                </div>
            ) : (
                <ImageEditor selectedGroup={selectedGroup} brushSize={brushSize} eraserSize={eraserSize} activeButton={activeButton} setEditUploadedImages={setEditUploadedImages} creditsAvailable={creditsAvailable} setCreditsAvailable={setCreditsAvailable} />
            )}

            <History
                All_History={allEditHistory}
                setSelectedGroup={setSelectedGroup}
                handleDownload={handleDownload}
                setEditUploadedImages={setEditUploadedImages}
                setActiveTab={setActiveTab}
                setModalImage={setModalImage}
                editPageNumber={editPageNumber}
                setEditPageNumber={setEditPageNumber}
                containerRef={containerRef}
                setAllEditHistory={setAllEditHistory}
            />
            {modalImage && (
                <ImageModal
                    image={modalImage}
                    onClose={() => setModalImage(null)}
                />
            )}
        </div>
    );
};

export default MainEdit;
